export default __webpack_public_path__ + "static/media/discord.91138065.svg";